import { useCallback } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { en } from '../translations/en';
import { es } from '../translations/es';

const translations = {
  en,
  es
};

export const useTranslation = () => {
  const { language } = useLanguage();
  
  const t = useCallback((key, params = {}) => {
    const keys = key.split('.');
    let translation = translations[language];
    
    // Navigate through nested keys
    for (const k of keys) {
      if (translation && translation[k]) {
        translation = translation[k];
      } else {
        // Fallback to English if translation not found
        translation = translations.en;
        for (const fallbackKey of keys) {
          if (translation && translation[fallbackKey]) {
            translation = translation[fallbackKey];
          } else {
            return key; // Return the key if no translation found
          }
        }
        break;
      }
    }
    
    // Replace parameters in the translation (use param in params so 0, false, '' are substituted)
    if (typeof translation === 'string') {
      return translation.replace(/\{(\w+)\}/g, (match, param) => {
        return param in params ? params[param] : match;
      });
    }
    
    return translation || key;
  }, [language]);
  
  return { t, language };
};
